import type { PropsWithChildren } from 'react'
import { createContext, useContext, useMemo } from 'react'
import { useExtensionInstalled } from '@/extension'

export interface MiscellaneousContextValue {
  isExtensionInstalled: boolean
}

export const MiscellaneousContext = createContext<MiscellaneousContextValue>({
  isExtensionInstalled: false
})

export function MiscellaneousProvider(props: PropsWithChildren) {
  const isExtensionInstalled = useExtensionInstalled()
  const value = useMemo(
    () => ({
      isExtensionInstalled
    }),
    [isExtensionInstalled]
  )

  return (
    <MiscellaneousContext.Provider value={value}>
      {props.children}
    </MiscellaneousContext.Provider>
  )
}

export function useMiscellaneousContext(): MiscellaneousContextValue {
  return useContext(MiscellaneousContext)
}
